import { render, staticRenderFns } from "./TabSectionView.vue?vue&type=template&id=6a897090"
import script from "./TabSectionView.vue?vue&type=script&lang=ts"
export * from "./TabSectionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports